// Cart & Cart Drawer: Terms & Conditions checkbox enforcement
// Intercepts form submit and finance button clicks at document level so it survives cart drawer re-renders.

(function () {
  if (window._cartTermsInit) return;
  window._cartTermsInit = true;

  var TERMS_ALERT = 'Please agree to the terms and conditions before making a purchase!';

  function getCheckboxForForm(formId) {
    if (formId === 'cart') return 'cart-terms-checkbox';
    if (formId === 'CartDrawer-Form') return 'cart-drawer-terms-checkbox';
    return null;
  }

  function isTermsChecked(checkboxId) {
    var cb = document.getElementById(checkboxId);
    return Boolean(cb && cb.checked);
  }

  document.addEventListener('submit', function (e) {
    if (!e.target) return;

    var checkboxId = getCheckboxForForm(e.target.id);
    if (!checkboxId) return;

    if (!isTermsChecked(checkboxId)) {
      e.preventDefault();
      alert(TERMS_ALERT);
    }
  });

  // Finance button is type="button" (not form submit), so enforce terms the same way on cart/drawer.
  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target.closest('[data-finance-open]');
      if (!trigger) return;

      var ctas = trigger.closest('.cart__ctas');
      if (!ctas) return;

      var cb = ctas.querySelector('.cart__terms-checkbox');
      if (cb && cb.checked) return;

      e.preventDefault();
      e.stopPropagation();
      alert(TERMS_ALERT);
    },
    true
  );
})();
